import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { LoggingService } from './logging.service';
import { environment } from '../environments/environment';

// Error handler combining Application Insights and Sentry with environment-aware guards
@Injectable()
export class CombinedErrorHandler extends Sentry.SentryErrorHandler {
  constructor(private loggingService: LoggingService) {
    super({ logErrors: false });
  }

  handleError(error: unknown): void {
    // Narrow unknown to Error where possible
    const err: Error = error instanceof Error ? error : new Error(typeof error === 'string' ? error : 'Unknown error');
    console.error('Error caught by CombinedErrorHandler:', err);

    // Application Insights (only if key present)
    if (environment.appInsights?.instrumentationKey) {
      try {
        this.loggingService.logException(err);
      } catch {
        // Intentionally empty - don't let AI logging failures break handler
      }
    }

    // Sentry (only if enabled)
    if (environment.sentry?.enabled) {
      try {
        super.handleError(err);
      } catch {
        // Intentionally empty - don't let Sentry failures break handler
      }
    }
  }
}
